import type {Status} from './types';

/**
 * Get the status text for the chat header, with an optional override via isOnline
 *
 * @param {Status} status - The status of the chat
 * @param {boolean} isOnline - Whether the chat is online
 * @returns {string} The status text
 */
export const getStatusText = (status: Status, isOnline?: boolean) => {
    if (isOnline !== undefined) {
        if (isOnline) {
            return 'Online';
        }

        return 'Offline';
    }

    switch (status) {
        case 'offline':
            return 'Offline';
        case 'form':
        case 'online':
        default:
            return 'Online';
    }
};

export const getFormFieldLabel = (field: string) => {
    switch (field) {
        case 'name':
            return 'Your name';
        case 'email':
            return 'company@example.com';
        case 'phone':
            return '555-555-5555';
        case 'companyName':
            return 'Arrowgrid';
    }
};
